import { render, staticRenderFns } from "./expPresMX.vue?vue&type=template&id=366bdd62"
import script from "./expPresMX.vue?vue&type=script&lang=js"
export * from "./expPresMX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports